export function decodeHtmlentities(encoded_text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = encoded_text;
    return textArea.value;
}
